/* @ngInject */
export default function iframeDirective() {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      element.on('load', () => {
        scope.$eval(attrs.iframeOnload);
      });

    }
  };
}
